import React, { useState, useRef } from 'react'
import { Popover, Paper, Box } from '@mui/material'
import classes from './NewSelectedField.module.css'
import { blueCross, blueFilter, FilterIcon } from '../../assets/icons'
import DatePickerField from '../NewDatePicker/NewDatePicker'
import { SelectField } from '../../components'

const NewSelectedField = ({
  student,
  grades,
  selectedGrade,
  selectedClass,
  selectedMonth,
  setSelectedClass,
  setSelectedGrade,
  setSelectedMonth,
  selectedDate,
  setSelectedDate,
  studentPresence,
  status = '',
  timeTable,
  handleDay,
  day,
  setDay,
  setViewedBy,
  setStatus,
  viewedby,
  fee,
  selectedType,
  setSelectedType,
  employeePresence,
}) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  const viewOptions = ['Teacher', 'Grade']
  const typeOptions = ['Teacher', 'Staff', 'Driver', 'All']

  const attendanceStatus = [
    { value: 'absent', label: 'Absent' },
    { value: 'present', label: 'Present' },
    { value: 'leave', label: 'On Leave' },
  ]

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  // Reset logic remains unchanged
  const handleClear = () => {
    if (student) {
      setSelectedGrade('')
      setSelectedClass('')
      // setSelectedMonth('')
    } else if (studentPresence) {
      setSelectedDate('')
    } else if (employeePresence) {
      setSelectedDate('')
      setSelectedType('')
      // setSelectedGrade('')
      // setSelectedClass('')
    } else if (timeTable) {
      setViewedBy('')
      setDay('')
    } else if (fee) {
      setSelectedGrade('')
      setSelectedClass('')
    } else if (timeTable) {
      setViewedBy('')
      setDay('')
    }
    setOpen(false) // Close popover after clear
  }

  const selectedGradeObj = grades?.find((g) => String(g.grade_id) === String(selectedGrade))

  return (
    <>
      {/* Trigger button – unchanged */}
      <div
        ref={anchorRef}
        onClick={handleToggle}
        className={`${classes.NewSelectedField} ${open ? classes.openBox : ''}`}
        aria-controls={open ? 'filter-menu' : undefined}
        aria-haspopup="true"
        role="button"
        tabIndex={0}
      >
        <img
          src={open ? blueFilter : FilterIcon}
          alt="Filter"
          width={24}
          height={24}
          className={classes.icon}
        />
      </div>

      {/* Popover instead of Popper */}
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={() => setOpen(false)} // ← Built-in close on outside click / Esc
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            elevation: 3,
            sx: {
              minWidth: 268,
              borderRadius: '8px',
              mt: 1,
              boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
              p: 2,
            },
          },
        }}
        // Optional: disable scroll lock if you don't want modal-like blocking
        // disableScrollLock={true}
      >
        {/* All your previous content – exactly the same */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <>
            {(student || studentPresence || fee) && (
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {/* Grade Dropdown */}
                {/* <Box className={classes.customSelectWrapper}>
                          <select
                            className={classes.select}
                            value={selectedGrade || ''}
                            onChange={onGradeChange}
                          >
                            <option value="">Select Grade</option>
                            {grades?.map((grade) => (
                              <option key={grade.grade_id} value={grade.grade_id}>
                                Grade : {grade.grade}
                              </option>
                            ))}
                          </select>
                          <img src={arrowDown} alt="Dropdown" className={classes.customArrow} />
                        </Box> */}
                {!employeePresence && (
                  <SelectField
                    placeholder={''}
                    options={(grades || [])?.map((prod) => ({
                      value: prod.grade_id,
                      label: prod.grade,
                    }))}
                    onChange={(selectedOption) => setSelectedGrade(selectedOption)}
                    value={selectedGrade || ''}
                    subLabel={'Grade :'}
                    filter
                  />
                )}

                {/* Section/Class Dropdown - only visible after grade selection */}
                {selectedGrade && (
                  <SelectField
                    placeholder={''}
                    options={(selectedGradeObj?.grade_sections || [])?.map((prod) => ({
                      value: prod.section_id,
                      label: prod.section,
                    }))}
                    onChange={(selectedOption) => setSelectedClass(selectedOption)}
                    value={selectedClass || ''}
                    subLabel={'Class :'}
                    filter
                  />
                )}
              </Box>
            )}
            {studentPresence && (
              <SelectField
                placeholder={''}
                options={(attendanceStatus || [])?.map((item) => ({
                  value: item.value,
                  label: item.label,
                }))}
                onChange={(selectedOption) => setStatus(selectedOption)}
                value={status || ''}
                subLabel={'Status :'}
                filter
                statusProp
              />
            )}
            {employeePresence && (
              <SelectField
                placeholder={''}
                options={(typeOptions || [])?.map((item) => ({
                  value: item,
                  label: item,
                }))}
                onChange={(selectedOption) => setSelectedType(selectedOption)}
                value={selectedType || ''}
                subLabel={'Type :'}
                filter
                statusProp
              />
            )}

            {!studentPresence &&
              !timeTable &&
              // <Box className={classes.customSelectWrapper}>
              //   <select
              //     className={classes.select}
              //     value={selectedMonth || ''}
              //     onChange={handleMonthChange}
              //   >
              //     <option value="">Select Month</option>
              //     {months?.map((month, index) => (
              //       <option key={index} value={month}>
              //         Month : {month}
              //       </option>
              //     ))}
              //   </select>
              //   <img src={arrowDown} alt="Dropdown" className={classes.customArrow} />
              // </Box>
              !fee &&
              !student && (
                <SelectField
                  placeholder={''}
                  options={(months || [])?.map((month) => ({
                    value: month,
                    label: month,
                  }))}
                  onChange={(selectedOption) => setSelectedMonth(selectedOption)}
                  value={selectedMonth || ''}
                  subLabel={'Month :'}
                  filter
                />
              )}

            {studentPresence && (
              <div className={classes.box}>
                <DatePickerField
                  value={selectedDate}
                  onChange={setSelectedDate}
                  format={(val) =>
                    val ? new Date(val).toLocaleDateString('en-IN') : 'Select Date'
                  }
                  containerClassName={selectedDate ? classes.dateSelected : ''}
                />
              </div>
            )}
            {timeTable && (
              <SelectField
                placeholder={''}
                options={(days || [])?.map((item) => ({
                  value: item,
                  label: item,
                }))}
                onChange={(selectedOption) => setDay(selectedOption)}
                value={day || ''}
                subLabel={'Day :'}
                filter
              />
            )}
            {timeTable && (
              // <Box className={classes.customSelectWrapper}>
              //   <select
              //     className={classes.select}
              //     value={viewedby || ''}
              //     onChange={handleViewedby}
              //   >
              //     <option value="">Select View</option>
              //     {viewOptions?.map((view, index) => (
              //       <option key={index} value={view}>
              //         View By : {view}
              //       </option>
              //     ))}
              //   </select>
              //   <img src={arrowDown} alt="Dropdown" className={classes.customArrow} />
              // </Box>
              <SelectField
                placeholder={''}
                options={(viewOptions || [])?.map((item) => ({
                  value: item,
                  label: item,
                }))}
                onChange={(selectedOption) => setViewedBy(selectedOption)}
                value={viewedby || ''}
                subLabel={'View By :'}
                filter
              />
            )}
            <button onClick={handleClear} className={classes.clear}>
              <p>Clear</p>
              <img src={blueCross} alt="Clear" className={classes.ico} />
            </button>
          </>
        </Box>
      </Popover>
    </>
  )
}

export default NewSelectedField
